import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Heart, Shield, Users, MapPin } from 'lucide-react';
import { Button } from '../components/Button';
export function About() {
  return <div className="pt-10" data-id="element-161" data-mp="29k5e92qfsuy5">
      {/* Hero */}
      <section className="bg-white py-20" data-id="element-162" data-mp="29lgh90c25yo7">
        <div className="container-custom" data-id="element-163" data-mp="2eigmj9132xe9">
          <div className="max-w-3xl mx-auto text-center" data-id="element-164" data-mp="2ej87zr0yveqt">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-165" data-mp="327rga6k0nriw">
              About Brixen Consulting
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-166" data-mp="3762s2mtvgc3r">
              We are a premier corporate services provider based in Dubai
              Silicon Oasis, dedicated to simplifying business setup and
              management for entrepreneurs and enterprises.
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="py-20 bg-gray-50" data-id="element-167" data-mp="1lukh9fxg7x5v">
        <div className="container-custom" data-id="element-168" data-mp="1lvm4eirqoa3y">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-169" data-mp="1uhicn90gca30">
            <div data-id="element-170" data-mp="1pioydedccf1s">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-171" data-mp="1pj8hgyeq99he">
                Our Mission
              </h2>
              <p className="text-gray-600 text-lg mb-6" data-id="element-172" data-mp="23iq9dmnbl2uz">
                To empower businesses with the structural foundation they need
                to thrive in the UAE. We believe that setting up a company
                should be transparent, efficient, and strategically sound.
              </p>
              <p className="text-gray-600 text-lg" data-id="element-173" data-mp="28gi2ul3m4x1a">
                We bridge the gap between complex regulations and business
                goals, acting as your trusted partner on the ground.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-6" data-id="element-174" data-mp="2i85y6x3aiy81">
              {[{
              icon: Shield,
              title: 'Integrity',
              desc: 'Honest advice, always.'
            }, {
              icon: Target,
              title: 'Excellence',
              desc: 'High standards in execution.'
            }, {
              icon: Users,
              title: 'Partnership',
              desc: 'We grow with you.'
            }, {
              icon: Heart,
              title: 'Transparency',
              desc: 'No hidden costs.'
            }].map((val, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-175" data-mp="2cjyy4sdzdqnd" data-mpi={idx}>
                  <val.icon className="h-8 w-8 text-blue-800 mb-4" data-id="element-176" data-mp="2gmc2bcd2xgi1" />
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-177" data-mp="2ll5ixdnnxnmf">{val.title}</h3>
                  <p className="text-sm text-gray-600" data-id="element-178" data-mp="m81dv50ecocs">{val.desc}</p>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Operating Model */}
      <section className="py-20 bg-white" data-id="element-179" data-mp="jn3fhptx967j">
        <div className="container-custom" data-id="element-180" data-mp="joy0131a6wb3">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-181" data-mp="ewn2g6u0jmlp">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-182" data-mp="evbwq1h0c4ry">
              Our Operating Model
            </h2>
            <p className="text-gray-600" data-id="element-183" data-mp="9v7eo70gb1zm">
              We combine internal expertise with a vetted network of partners to
              deliver comprehensive solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-184" data-mp="12jv6klfpgpm5">
            <div className="p-8 border border-gray-100 rounded-xl bg-slate-50" data-id="element-185" data-mp="xnxni7d2555o">
              <div className="text-4xl font-bold text-blue-200 mb-4" data-id="element-186" data-mp="smqfc77063yh">01</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-187" data-mp="on7wdgyqs2ya">
                Internal Execution
              </h3>
              <p className="text-gray-600" data-id="element-188" data-mp="3df206fey7x7a">
                Core corporate services, documentation, and compliance
                management handled in-house.
              </p>
            </div>
            <div className="p-8 border border-gray-100 rounded-xl bg-slate-50" data-id="element-189" data-mp="1137brwsmk0op">
              <div className="text-4xl font-bold text-blue-200 mb-4" data-id="element-190" data-mp="15uz2c7bs66eu">02</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-191" data-mp="r62xsk8xnbiz">
                Strategic Partners
              </h3>
              <p className="text-gray-600" data-id="element-192" data-mp="w44itapx5kx3">
                Collaboration with top-tier banks, auditors, and legal firms for
                specialized needs.
              </p>
            </div>
            <div className="p-8 border border-gray-100 rounded-xl bg-slate-50" data-id="element-193" data-mp="1ottjto2mpkyp">
              <div className="text-4xl font-bold text-blue-200 mb-4" data-id="element-194" data-mp="1au29bxbbmmpg">03</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-195" data-mp="1aw4xscwts7s2">
                Client Focus
              </h3>
              <p className="text-gray-600" data-id="element-196" data-mp="3vk16dbqtvbda">
                Dedicated account managers ensuring seamless communication and
                delivery.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Location Advantage */}
      <section className="py-20 bg-blue-900 text-white" data-id="element-197" data-mp="3s09045a9zxq8">
        <div className="container-custom" data-id="element-198" data-mp="3n3iopv9f1qb5">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-199" data-mp="3n2r2hb1pl4xj">
            <div data-id="element-200" data-mp="5tkl9832nnju">
              <div className="flex items-center mb-6" data-id="element-201" data-mp="5u3zoetijtt4">
                <MapPin className="h-6 w-6 text-blue-400 mr-2" data-id="element-202" data-mp="vizgfe9ha4o" />
                <span className="text-blue-200 font-semibold tracking-wide uppercase" data-id="element-203" data-mp="ty26i0kbd34">
                  Location Advantage
                </span>
              </div>
              <h2 className="text-3xl font-bold mb-6" data-id="element-204" data-mp="34e2kawum1dpg">
                Based in Business Bay
              </h2>
              <p className="text-blue-100 text-lg mb-6 leading-relaxed" data-id="element-205" data-mp="3j2qeozspzhdt">
                Our headquarters at Iris Bay Tower places us at the heart of
                Dubai's business and financial district. This strategic location
                allows us to offer competitive Free Zone packages and access to
                a vibrant ecosystem of tech companies and startups.
              </p>
              <Link to="/contact" data-id="element-206" data-mp="3b9x2eg0v5oci">
                <Button className="bg-white text-blue-900 hover:bg-gray-100 border-none" data-id="element-207" data-mp="3fbimomfq94wq">
                  Visit Our Office
                </Button>
              </Link>
            </div>
            <div className="relative h-80 rounded-2xl overflow-hidden bg-blue-800 border border-blue-700" data-id="element-208" data-mp="3p1k979sfmf9j">
              {/* Abstract representation of map/location */}
              <div className="absolute inset-0 opacity-30 bg-[url('https://images.unsplash.com/photo-1512453979798-5ea904ac8489?auto=format&fit=crop&q=80&w=2070')] bg-cover bg-center" data-id="element-209" data-mp="2sd47kfc1sfg2"></div>
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-210" data-mp="31aek040lqamk">
                <div className="bg-white/10 backdrop-blur-md p-6 rounded-xl border border-white/20 text-center" data-id="element-211" data-mp="36c3yxuqy38fx">
                  <p className="font-bold text-xl" data-id="element-212" data-mp="gl8nh8tgnf8f">Iris Bay Tower</p>
                  <p className="text-sm text-blue-100" data-id="element-213" data-mp="lk243a41nmct">Business Bay, Dubai</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Compliance Statement */}
      <section className="py-16 bg-white border-t border-gray-100" data-id="element-214" data-mp="214ucr7vvip4e">
        <div className="container-custom max-w-4xl text-center" data-id="element-215" data-mp="1wcsyjgf5aobq">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-216" data-mp="1wazr3ywpk02o">
            Compliance & Ethics
          </h2>
          <p className="text-gray-600 leading-relaxed" data-id="element-217" data-mp="1rc59h0ah8hk5">
            Brixen Consulting FZCO operates with strict adherence to UAE
            regulations. We are committed to maintaining the highest ethical
            standards in all our business dealings. We conduct thorough KYC
            (Know Your Customer) checks and ensure all our clients comply with
            local laws.
          </p>
        </div>
      </section>
    </div>;
}